import { requestPrice } from '../actions'


const asyncValidate = (values, dispatch) => {
	if (values.service==="translation" || values.service==="official") {
		if (values.currency && values.sourceLanguage && values.targetLanguage && values.totalQty) {
			if (values.certification===true && !values.requestOrigin) {
				return Promise.resolve();
			}
			return dispatch(requestPrice());
		} else {
			return Promise.resolve();
		}
	} else if (values.service==="interpreting") {
		if (values.currency && values.sourceLanguage && values.targetLanguage && values.interpretingDuration && values.interpretorsNumber && values.interpretingType) {
			return dispatch(requestPrice());
		} else {
			return Promise.resolve();
		}
	} else if (values.service==="coaching") {
		if (values.currency && values.coachingLanguage && values.coachingLevel) {
			return dispatch(requestPrice());
		} else {
			return Promise.resolve();
		}
	} else {
		return Promise.resolve();
	}

}


export default asyncValidate


// WEBPACK FOOTER //
// ./src/validations/asyncValidate.js